module.exports = __webpack_public_path__ + "static/img/account.bc7fa00.svg";